import assignIn from 'lodash/assignIn'
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'

class Form {
  constructor(values) {
    this.$errors = {}
    this.$busy = false
    this.$originalData = cloneDeep(values)
    assignIn(this, values)
  }

  /**
   * Returns the values based on original fields
   *
   * @returns {Object}
   */
  $data() {
    let data = cloneDeep(this.$originalData)
    each(this.$originalData, (_, key) => {
      data[key] = this[key]
    })

    return data
  }

  /**
   * Reset the form to its original phase
   * Set the original data values
   * Clear errors
   */
  $reset() {
    assignIn(this, this.$originalData)
    this.$clearErrors()
  }

  /**
   * Set loading state and reset errors
   * @param {Boolean} bool
   */
  $setLoading(bool) {
    this.$busy = bool
    if (bool) {
      this.$clearErrors()
    }
  }

  /**
   * Set the form errors
   * @param {Oject, Array} errors
   */
  $setErrors(errors) {
    this.$errors = errors
  }

  /**
   * Clear all form errors
   */
  $clearErrors() {
    this.$errors = {}
  }

  /**
   * Clear the errors in a specific field
   *
   * @param {String} field
   */
  $clearError(field) {
    delete this.$errors[field]
  }

  /**
   * Check if the field has error
   *
   * @param {String} field
   * @returns {Boolean}
   */
  $hasError(field) {
    return !!this.$errors[field]
  }

  /**
   * Get the error description of a specific field
   *
   * @param {String} field
   * @returns {String}
   */
  $getError(field) {
    return this.$errors[field]
  }

  $handleError(error) {
    this.$busy = false
    if (!error.response) {
      // console.log(error)
    } else if (error.response.status === 401) {
      this.$errorMessage = 'Unauthenticated or session has expired'
    } else if (error.response.status === 422) {
      this.$errors = error.response.data.errors
      this.$errorMessage = 'There are items that require your attention'
    } else if (error.response.status === 500) {
      this.$errorMessage =
        'Sorry, something went wrong. Try again later or contact us if the problem persists'
    } else {
      this.$errorMessage = error.response.data.message
    }
  }
}

export default Form
